import { gql } from '@apollo/client';

import { BusinessHoursFragmentDoc } from '../../graphql/fragments/BusinessHours.generated';
import type * as GraphQLTypes from '../../graphql/types.generated';
export type NetworksCreateOrganisationMutationVariables = GraphQLTypes.Exact<{
  input: GraphQLTypes.CreateOrganisationInput;
}>;

export type NetworksCreateOrganisationMutationResult = { __typename?: 'Mutation' } & {
  networksCreateOrganisation?: GraphQLTypes.Maybe<
    { __typename?: 'CreateOrganisationPayload' } & {
      errors?: GraphQLTypes.Maybe<Array<{ __typename?: 'Error' } & Pick<GraphQLTypes.Error, 'message' | 'path'>>>;
      organisation?: GraphQLTypes.Maybe<
        | ({ __typename?: 'AgentOrganisation' } & Pick<GraphQLTypes.AgentOrganisation, 'id'>)
        | ({ __typename?: 'ForwarderOrganisation' } & Pick<GraphQLTypes.ForwarderOrganisation, 'id'>)
        | ({ __typename?: 'MyOrganisation' } & Pick<GraphQLTypes.MyOrganisation, 'id'>)
        | ({ __typename?: 'SavedOrganisation' } & Pick<GraphQLTypes.SavedOrganisation, 'id'>)
      >;
      orgLoc?: GraphQLTypes.Maybe<
        { __typename?: 'NetworksOrgLoc' } & Pick<GraphQLTypes.NetworksOrgLoc, 'id' | 'timeZone'> & {
            contact?: GraphQLTypes.Maybe<
              { __typename?: 'NetworksOrgLocContact' } & Pick<
                GraphQLTypes.NetworksOrgLocContact,
                'email' | 'firstName' | 'id' | 'lastName' | 'phoneNumber'
              >
            >;
            label?: GraphQLTypes.Maybe<
              { __typename?: 'NetworksLabelType' } & Pick<GraphQLTypes.NetworksLabelType, 'long' | 'short'>
            >;
            location?: GraphQLTypes.Maybe<
              { __typename?: 'NetworksOrgLocLocation' } & Pick<GraphQLTypes.NetworksOrgLocLocation, 'id' | 'name'> & {
                  address?: GraphQLTypes.Maybe<
                    { __typename?: 'LegacyAddress' } & Pick<
                      GraphQLTypes.LegacyAddress,
                      'city' | 'countyOrState' | 'postalCodeOrZip' | 'street'
                    > & { country?: GraphQLTypes.Maybe<{ __typename?: 'Country' } & Pick<GraphQLTypes.Country, 'code' | 'name'>> }
                  >;
                  businessHours?: GraphQLTypes.Maybe<
                    { __typename?: 'BusinessHours' } & {
                      monday?: GraphQLTypes.Maybe<
                        { __typename?: 'TimeRange' } & Pick<GraphQLTypes.TimeRange, 'startTime' | 'endTime'>
                      >;
                      tuesday?: GraphQLTypes.Maybe<
                        { __typename?: 'TimeRange' } & Pick<GraphQLTypes.TimeRange, 'startTime' | 'endTime'>
                      >;
                      wednesday?: GraphQLTypes.Maybe<
                        { __typename?: 'TimeRange' } & Pick<GraphQLTypes.TimeRange, 'startTime' | 'endTime'>
                      >;
                      thursday?: GraphQLTypes.Maybe<
                        { __typename?: 'TimeRange' } & Pick<GraphQLTypes.TimeRange, 'startTime' | 'endTime'>
                      >;
                      friday?: GraphQLTypes.Maybe<
                        { __typename?: 'TimeRange' } & Pick<GraphQLTypes.TimeRange, 'startTime' | 'endTime'>
                      >;
                      saturday?: GraphQLTypes.Maybe<
                        { __typename?: 'TimeRange' } & Pick<GraphQLTypes.TimeRange, 'startTime' | 'endTime'>
                      >;
                      sunday?: GraphQLTypes.Maybe<
                        { __typename?: 'TimeRange' } & Pick<GraphQLTypes.TimeRange, 'startTime' | 'endTime'>
                      >;
                    }
                  >;
                  geolocation?: GraphQLTypes.Maybe<
                    { __typename?: 'Geolocation' } & Pick<GraphQLTypes.Geolocation, 'latitude' | 'longitude'>
                  >;
                }
            >;
            organisation?: GraphQLTypes.Maybe<
              { __typename?: 'NetworksOrgLocOrganisation' } & Pick<GraphQLTypes.NetworksOrgLocOrganisation, 'id' | 'name'>
            >;
          }
      >;
    }
  >;
};

export const NetworksCreateOrganisationDocument = gql`
  mutation networksCreateOrganisation($input: CreateOrganisationInput!) {
    networksCreateOrganisation(input: $input) {
      errors {
        message
        path
      }
      organisation {
        id
      }
      orgLoc {
        contact {
          email
          firstName
          id
          lastName
          phoneNumber
        }
        id
        label {
          long
          short
        }
        location {
          address {
            city
            country {
              code
              name
            }
            countyOrState
            postalCodeOrZip
            street
          }
          businessHours {
            ...BusinessHours
          }
          geolocation {
            latitude
            longitude
          }
          id
          name
        }
        organisation {
          id
          name
        }
        timeZone
      }
    }
  }
  ${BusinessHoursFragmentDoc}
`;
